import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import ClientDetail from '../component/client/ClientDetail';
import ClientFilterableList from '../component/client/ClientFilterableList';

export default function ClientsPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:clientId?`;
  const match = useRouteMatch<{ clientId?: string }>(path);
  const clientId = match?.params.clientId;

  return (
    <ResponsiveContextProvider single={false} selectedId={clientId}>
      <Route path={path}>
        <Container>
          <Row>
            <ResponsiveListCol>
              <div className="position-fixed-scrollable">
                <ClientFilterableList clientId={clientId} url={parentUrl} />
              </div>
            </ResponsiveListCol>

            <ResponsiveDetailCol>
              <ClientDetail clientId={clientId} listUrl={parentUrl} />
            </ResponsiveDetailCol>
          </Row>
        </Container>
      </Route>
    </ResponsiveContextProvider>
  );
}
